import React, { useState, useEffect, useRef } from 'react';
import './CodeEditor.css';
import './TeacherDashboard.css';

let backendURL = process.env.REACT_APP_BACKEND_WS_URL
if (backendURL == null){
    backendURL = "ws://localhost:8000"
}

const TeacherDashboard: React.FC = () => {
  const [studentTexts, setStudentTexts] = useState<{ [studentId: string]: string }>({});
  const ws = useRef<WebSocket | null>(null); // Initialize the ref

  useEffect(() => {
    

    ws.current = new WebSocket(backendURL + '/ws/teacher');

    ws.current.onmessage = (event) => {
      console.log('Message received: ', event.data);
      const message = JSON.parse(event.data);
      console.log('json parsed message: ', message);

      const { studentId, text, studentConnectionsCount, teacherConnectionsCount } = message;
  
      console.log('Extracted studentId, text, studentConnectionsCount, teacherConnectionsCount: ', studentId, text, studentConnectionsCount, teacherConnectionsCount);
      
      setStudentTexts(prevUpdates => ({
        ...prevUpdates,
        [studentId]: text
      }));
    };

    ws.current.onopen = () => {
      console.log('WebSocket Connected');
    };

    ws.current.onclose = () => {
      console.log('WebSocket Disconnected');
    };

    ws.current.onerror = (error) => {
      console.error('WebSocket Error: ', error);
    };


    return () => {
      if (ws.current) {
        ws.current.close();
      }
    };
  }, []);

  const renderTextAreas = () => {
    console.log('studentTexts: ', studentTexts);
    const entries = Object.entries(studentTexts);
    const rows = [];
    console.log('entries: ', entries);
    for (let i = 0; i < entries.length; i += 3) {
      const slice = entries.slice(i, i + 3);
      const row = (
        <div key={i} className="row mb-3">
          {slice.map(([studentId, text]) => (
            <div key={studentId} className="col-4">
              <textarea className="form-control dashboard-texts" value={text} readOnly />
            </div>
          ))}
        </div>
      );
      rows.push(row);
    }
    return rows;
  };

  return (
    <div className="editor-container">
      <br/>
      <h1>Teacher Dashboard</h1>
      {renderTextAreas()}
    </div>
  );
};

export default TeacherDashboard;
